export default {
	en: 'English',
	kk: 'Қазақ',
	uk: 'Українська',
	tr: 'Türkçe',
	uz: 'Oʻzbekcha',
	ru: 'Русский',
}
